import React from "react";
import CampaignsList from "./CampaignsList";

const CampaignsManagement = () => {
    return (
        <div className="campaigns-management-container">
            <CampaignsList />
        </div>
    );
};

export default CampaignsManagement; 